<template>
	<div class="user-info-right">
		<template v-if="userInfo.username">
			<div class="user-avatar">
				<img class="poster-image" :src="userInfo | imgUrl('headImage')" />
			</div>
			<p class="user-name">{{userInfo.username}}</p>
			<!-- <div class="user-other">
				<router-link :to="{name: 'circlesFans'}">粉丝：{{userDetail.fansCount}}</router-link>  |  <router-link :to="{name: 'circlesFollow'}">关注：{{userDetail.followCount}}</router-link>  |  <router-link :to="{name: 'myCircles'}">已发圈子：{{userDetail.culturalCount}}</router-link>
			</div> -->
			<div class="btn-groups">
				<!-- <router-link class="btn-primary btn-xs" :to="{name: 'privateLetter'}">好友私信</router-link> -->
				<router-link class="btn-primary btn-xs" :to="{name: 'systemMessage'}">系统私信</router-link>
				<!-- <router-link class="btn-primary btn-xs" :to="{name: 'interaction'}">我的互动</router-link> -->
			</div>
		</template>
		<template v-else>
			<div class="user-avatar">
				<img src="~@/assets/img/main/avatar.png" />
			</div>
			<div class="no-login-box">
				<p class="no-login-text">未登录</p>
				<p class="no-login-text">登录后查看更多信息</p>
			</div>
		</template>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				userDetail: {}
			}
		},
		computed: {
			...mapState({
				userInfo: state => state.user.userInfo
			}),
		},
		created() {
			if(this.userInfo.username){
				this.culturalMemberInfo();
			}
		},
		methods: {
			async culturalMemberInfo() {
				let res = await this.$http('culturalMemberInfo', {
					userId: this.userInfo.id
				});
				if(res.code === 1){
					this.userDetail = res.data;
				}
			},
		}
	}
</script>

<style lang="scss">
	.user-info-right{
		background-color: #fff;
		border:1px solid rgba(222,222,222,1);
		border-top: 3px solid #0260FE;
		padding: 34px 18px 18px;
		
		.btn-groups{
			margin-top: 32px;
			// padding-right: 20px;
			overflow: hidden;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.btn-primary{
				// width: 33.3333333%;
				// float: left;
				padding: 0 10px;
				// &:nth-last-child(3n){
				// 	float: right;
				// 	margin-right: -20px;
				// }
			}
		}
		.user-other{
			font-size:14px;
			font-weight:400;
			color:rgba(91,91,91,1);
			line-height:18px;
			margin-top: 46px;
			text-align: center;
			white-space: nowrap;
		}
		.no-login-box{
			padding: 40px 0;
		}
		.no-login-text{
			font-size: 16px;
			font-weight: 400;
			color: #196FFD;
			line-height: 32px;
			text-align: center;
		}
		.user-name{
			font-size:18px;
			font-weight:400;
			color:rgba(32,42,48,1);
			line-height:18px;
			margin-top: 37px;
			text-align: center;
		}
		.user-avatar{
			img{
				width: 110px;
				height: 110px;
				display: block;
				margin: 0 auto;
				border-radius: 100%;
			}
		}
	}
</style>
